export function getPartnerLogo(partnerLogoName: string): string {
	return `${window.CONFIG.API_ROOT}/file/partnerLogo/${partnerLogoName}`;
}

export function getPartnerLogoLead(partnerLogoName: string): string {
	return `${window.CONFIG.API_ROOT}/Lead/Logo/${partnerLogoName}`;
}
